import styles from './installStatus.module.css';
import { useHistory } from "react-router-dom";
import { Button } from '@progress/kendo-react-buttons';
import kendo from "@progress/kendo-ui";
import { roundNum } from '../../../com/dataUtil';

// 카카오 적용
const { kakao } = window;

const ElderInfoItem = props => {
  const { dataItem } = props;

  const date = new Date();
  const history = useHistory();

  // 맵 이동 이벤트
  const movePostEvt = e => {
    let lati = dataItem.lat;
    let longi = dataItem.lng;
    const map = dataItem.map;
    if (map) {
      // lati , longi 값이 빈값으로 들어오면 천안시청으로 이동
      if (!lati) {
        lati = 36.81508;
      }
      if (!longi) {
        longi = 127.11392;
      }
      const moveLocation = new kakao.maps.LatLng(lati, longi);
      map.setCenter(moveLocation);
      map.setLevel(1);
    }
  };

  // 20001	20	1	정상	30분 이내 수신 데이터 10개 이상
  // 20002	20	2	경고	30분 이내 수신 데이터 10개 미만
  // 20003	20	3	미작동	3시간 이내 수신 데이터 0개
  // 20004	20	4	위험
  // 설비 상태 아이콘 URL
  const getMeainStatIcon = () => {
    let src = '';
    if (dataItem.meainStatCode === '20001') {
      src = '/images/chncareweb/icon_normal.png';
    } else if (dataItem.meainStatCode === '20002') {
      src = '/images/chncareweb/icon_warn.png';
    } else if (dataItem.meainStatCode === '20003') {
      src = '/images/chncareweb/icon_unoper.png';
    } else if (dataItem.meainStatCode === '20004') {
      src = '/images/chncareweb/icon_emer.png';
    }
    return src;
  };

  // 유저 상태 메시지
  const getUserStatText = () => {

    let text = dataItem.userTerm + '님의 설비는 미작동 설비입니다.';

    // 조건문 안에서 다양한 활동 표출 (사용자 특징 하드코딩)
    if ( dataItem.dataStatTerm === '고활동' ) {
      text = '현재 ' + dataItem.userTerm + '님은 고활동 상태입니다.'
    } else if ( dataItem.dataStatTerm === '저활동' ) {
      text = '현재 ' + dataItem.userTerm + '님은 저활동 상태입니다.'
    } else if ( dataItem.dataStatTerm === '식사' ) {
      text = '현재 ' + dataItem.userTerm + '님은 식사 중입니다.'
    } else if ( dataItem.dataStatTerm === '수면' ) {
      text = '현재 ' + dataItem.userTerm + '님은 수면 중입니다.'
    } else if ( dataItem.dataStatTerm === '자리비움' ) {
      if(dataItem.latestDataStatTime < 60) {
        text = dataItem.userTerm + '님은 단시간 자리비움 상태입니다.'
      } else {
        text = dataItem.userTerm + '님은 장시간 자리비움 상태입니다.'
      }
    }
    
    
    return text;
  };

  const dongCode = dataItem.dongCode;
  const dongTermSimple = dataItem.dongTermSimple;
  const elderTerm = dataItem.userTerm;
  const elderId = dataItem.userId;
  const startDtm = new Date();
  const endDtm = new Date();
  const radio = "HH";

  const elderLogBtnClickEvt = () => {
    history.push({
      pathname: "/log/elder",
      state: { dongCode, dongTermSimple, elderTerm, elderId, startDtm, endDtm, radio },
    });
  };

  return (
    <>
      <table className="userStatTb" onClick={movePostEvt}>
        <tbody>
          <tr className='top'>
            <th>
              <img className={styles.meainStatIcon} src={getMeainStatIcon()} />
              &nbsp; &nbsp;
              <span>
                {dataItem.userTerm}({dataItem.dongTermSimple})
              </span>
              &nbsp;&nbsp;
              {dataItem.dangerElderYn === 'Y' && <img className={styles.iconArea} src="/images/chncareweb/icon_bell_23.png" />}
              {dataItem.bizType === '5001' && <img className={styles.iconArea} src="/images/chncareweb/icon_set_23.png" />}
              <Button className="elderLogBtn" onClick={elderLogBtnClickEvt}>대상자정보</Button>
            </th>
            <td>온도</td>
            <td>조도</td>
          </tr>
          <tr className='bottom'>
            <th colSpan={1}>
              <span className='statText'>{getUserStatText()}</span>
            </th>
            <td >
              <span className=''>
                {dataItem.temperature === null ?
                  '-'
                  : dataItem.temperature }
                {/* {dataItem.temperature === null ? '-' : dataItem.temperature} */}
              </span>
            </td>
            <td >
            <span className=''>{dataItem.light === null ? '-' : dataItem.light}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </>
  );
};

export default ElderInfoItem;
